const escapeCookieNameForRegex = (name) => {
    return name.replace(/[$()*+.?[\\\]^{|}]/g, '\\$&');
}

const getCookie = (name) => {
    if (typeof document === 'undefined') return undefined;
    const escaped = escapeCookieNameForRegex(name);
    const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${escaped}=([^;]*)`));
    if (!match) return undefined;
    try {
        return decodeURIComponent(match[1]);
    } catch {
        return match[1];
    }
}

export const getUtmCookie = () => {
    if (typeof document === 'undefined') return {};
    const medium = getCookie('cust-utm-medium');
    const source = getCookie('cust-utm-source');
    const result = {};
    if (medium) result.medium = medium;
    if (source) result.source = source;
    return result;
}

export const buildUtmQueryAfterSource = (utmCookie) => {
    const utmParams = new URLSearchParams();
    if (utmCookie?.medium) utmParams.set('utm_medium', utmCookie.medium);
    if (utmCookie?.source) utmParams.set('utm_source', utmCookie.source);
    const s = utmParams.toString();
    return s ? `#/?${s}` : '';
  }